import angular from 'angular';
import getReproductionComponent from './get-reproduction.component';
import getReproductionService from './get-reproduction.service';

let getReproductionModule = angular.module('getReproduction', [])

    .component('getReproduction', getReproductionComponent)
    .service('getReproductionService', getReproductionService)

    .name;

let states = [];

export default {name: getReproductionModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/original/get-reproduction/get-reproduction.js